import React, { Component } from 'react';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import { connect } from 'react-redux';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import { DATATABLE_CONFIG, SHIFT_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';

class PeriodicWorkSchedule extends Component {
    state = {
        display : true,
        departmentList : [
            {
                label: '---Select Concerned Department---',
                value : null
            },
            {
                label: 'IT',
                value : 'IT'
            },
            {
                label: 'Finance Mangement',
                value : 'Finance Mangement'
            }
        ],
        globalFilter: null,
        dataTableValue: [{
            code : "PW1",
            name : "Second Work Schedule",
            description : "Follows up PWI" 
        },{
            code : "PW2",
            name : "Second Work Schedule",
            description : "Follows up PWI" 
        },{
            code : "PW3",
            name : "Second Work Schedule",
            description : "Follows up PWI" 
        }
    ],
    selectedCustomers:[]
    }



    deleteDocType = () => {

        if(this.state.selectedCustomers.length > 0){


        const updatedDocValue = this.state.selectedCustomers.map( value => {
            return value.code;
        })
        const filteredValue = this.state.dataTableValue.filter(doc => {

            return updatedDocValue.includes(doc.code) === false;
         
        });
        this.setState({dataTableValue:filteredValue})
        }
        else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select checkbox'});
        }

        // const updatedDeptValue = this.state.dataTableValue.filter((value,index) => {
        //     return removeIndex !== index;
        // })
        // this.setState({dataTableValue:updatedDeptValue})

    }


   


    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                <Link to={"/periodic-schedule/edit/"+rowData.id}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }

            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                <Link to={"/periodic-schedule/view/"+rowData.id}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
        </div>;
    }


 
    componentDidMount(){
        //this.props.getShiftPatternData();
        this.getAccess = HASACCESS(SHIFT_SUBMENU_ID);
        this.props.getMasterTableList('GetShiftPattern');  
    }

  
    render() {   

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        let { shiftPatternData = []  } = this.props;
        if(shiftPatternData.shiftPatternList!==undefined && shiftPatternData.shiftPatternList.length > 0){
            shiftPatternData = shiftPatternData.shiftPatternList;
        }
        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        return (
            <div className="p-grid search">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Shift Pattern</h1>
               
                        <div className="p-grid">

                            <div className="p-col-12  p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                <Link to="/periodic-schedule/add/new"><Button style={{float: 'right'}} label="Add Shift Pattern" icon="pi pi-plus" className="ml1" /></Link>
                                }
                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&

                                <Button onClick={this.deleteDocType} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }
                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>


                     
                        <DataTable value={shiftPatternData}   
                         selection={this.state.selectedCustomers} onSelectionChange={e => this.setState({selectedCustomers: e.value})}
                         globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="code" header="Code" sortable={true} />
                                <Column field="name" header="Name" sortable={true} />
                                <Column field="description" header="Description" sortable={true} />
                                <Column body={this.actionTemplate} header="Action" style={{textAlign:'center', width: '8em'}}/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        shiftPatternData: state.master.tableLists
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getShiftPatternData: () => dispatch(actions.getShiftPatternData()),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PeriodicWorkSchedule);